import { request } from "./apiClient";

export const sessionService = {
  getAllSessions: (token) =>
    request(`/sessions`, { token }),

  getSessionById: (token, sessionId) =>
    request(`/sessions/${sessionId}`, { token }),

  
  createSession: (token, payload) =>
    request(`/sessions`, {
      method: "POST",
      token,
      body: payload,
    }),

  
  updateSession: (token, sessionId, payload) =>
    request(`/sessions/${sessionId}`, {
      method: "PATCH",
      token,
      body: payload,
    }),

  
  endSession: (token, sessionId, payload = {}) =>
    request(`/sessions/${sessionId}/end`, {
      method: "PATCH",
      token,
      body: payload,
    }),

  
  /** Người dùng chuyển sang trang mới trong cùng phiên (không retry — tracking không quan trọng bằng UX). */
  trackPageview: (sessionId, path) =>
    request(`/sessions/${sessionId}/pageview`, { method: "POST", body: { path }, retry: { retries: 0 } }),

  /** Nhịp "còn đang xem" để admin thấy số người đang online. */
  ping: (sessionId) =>
    request(`/sessions/${sessionId}/ping`, { method: "POST", retry: { retries: 0 } }),

  deleteSession: (token, sessionId) =>
    request(`/sessions/${sessionId}`, {
      method: "DELETE",
      token,
    }),
};